module.exports = __webpack_public_path__ + "public/Icons/colorPickerIcon.svg?595a0889";